const getDevicesInactive = state => state.devicesInactive;
const getDevicesOnline = state => state.devicesOnline;
const getDevicesOffline = state => state.devicesOffline;
const getSubscribedVehicles = state => state.trackingVehicles;
const getSubscribedVehiclesFleetCounter = state => state.subscribedVehiclesFleetCounter;
const getFilters = state => state.filters;
const getCenterCar = state => state.centerCar;
const getVehicleJourney = state => state.vehicleJourney;
const getJourneysData = state => state.journeysData;
const getActiveJourneys = state => state.activeJourneys;
const getIsJourneyLoading = state => state.isJourneyLoading;
const getDeviceStatistics = state => state.deviceStatistics;
const getTrackingVehicles = state => state.trackingVehicles;
const getJourneyVehicles = state => state.journeyVehicles;
const getCurrentJourney = state => state.currentJourney;
const getCurrentVehicle = state => state.currentVehicle;
const getSelectedJourneys = state => state.selectedJourneys;
const showIdlePoints = state => state.showIdlePoints;
const showRawData = state => state.showRawData;
const showSpeedingData = state => state.showSpeedingData;
const getIsLoading = state => state.isLoading;
const getIsTrackingAsideLoading = state => state.isTrackingAsideLoading;
const getIsJourneyTabActive = state => state.isJourneyTabActive;
const getOpenAutoJourney = state => state.openAutoJourney;
const getDateInJourneyTab = state => state.dateInJourneyTab;
const getUpdateSharedEvent = state => state.updatedSharedEvent;
const getIsClusteringActive = state => state.isClusteringActive
const getIsOpenActionJourneyTab = state => state.isOpenActionJourneyTab
const getLastActiveDate = state => state.lastActiveDate

export default {
    getDevicesInactive,
    getDevicesOnline,
    getDevicesOffline,
    getSubscribedVehicles,
    getSubscribedVehiclesFleetCounter,
    getFilters,
    getCenterCar,
    getVehicleJourney,
    getJourneysData,
    getActiveJourneys,
    getIsJourneyLoading,
    getDeviceStatistics,
    getTrackingVehicles,
    getJourneyVehicles,
    getCurrentJourney,
    getCurrentVehicle,
    getSelectedJourneys,
    showIdlePoints,
    showRawData,
    getIsLoading,
    getIsTrackingAsideLoading,
    getIsJourneyTabActive,
    getOpenAutoJourney,
    getDateInJourneyTab,
    showSpeedingData,
    getUpdateSharedEvent,
    getIsClusteringActive,
    getIsOpenActionJourneyTab,
    getLastActiveDate
};
